import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

interface RecommendedProductResponse {
  product: {
    allowedRequestTypes: null | string;
    description: null | string;
    features: string[];
    id: number;
    monthlyPrice: null | number;
    stripeMonthlyProductId: null | string;
    title: string;
  };
  recommendation: {
    basedOn: string[];
    confidence: number;
    reason: string;
  };
}

interface UseRecommendedProductParams {
  projectId: number;
}

export function useRecommendedProduct({
  projectId,
}: UseRecommendedProductParams) {
  return useQuery<RecommendedProductResponse>({
    enabled: false,
    queryFn: async () =>
      await apiClient
        .url("/products/recommended")
        .query({ projectId })
        .get()
        .json<RecommendedProductResponse>(),
    queryKey: ["recommendedProduct", projectId],
    staleTime: 0,
  });
}
